export default "__VITE_ASSET__ae460336__"